<template>
  <b-modal v-model="editorShown" hide-footer centered title="Risk Indicators">
    <div class="p-2">
      <b-row class="mb-3">
        <b-col md="8">
          <div class="bg-extra-light-gray">
            <span class="ml-4">NARX SCORES</span>
            <div class="d-flex flex-column justify-content-center">
              <b-row>
                <b-col>
                  <small>Narcotic</small>
                  <div class="large">
                    {{
                      narxScores.find(s => s.scoreType == "Narcotics")
                        .scoreValue
                    }}
                  </div>
                </b-col>
                <b-col>
                  <small>Sedative</small>
                  <div class="large">
                    {{
                      narxScores.find(s => s.scoreType == "Sedatives")
                        .scoreValue
                    }}
                  </div>
                </b-col>
                <b-col>
                  <small>Stimulant</small>
                  <div class="large">
                    {{
                      narxScores.find(s => s.scoreType == "Stimulants")
                        .scoreValue
                    }}
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
        <b-col md="4">
          <div
            class="d-flex flex-column justify-content-center bg-extra-light-gray h-100"
          >
            <b-row>
              <b-col>
                <span>OVERDOSE RISK SCORE</span>
                <div class="large">
                  {{
                    narxScores.find(s => s.scoreType == "Overdose").scoreValue
                  }}
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <div v-for="(message, index) in narxMessages" :key="index">
        <small
          ><i class="fas fa-info-circle mr-1 text-primary"></i>[{{
            message.messageType
          }}] {{ message.messageText }}</small
        >
      </div>
      <div class="d-flex justify-content-center mt-3">
        <b-button
          v-for="(report, index) in reportRequestURLs"
          :key="index"
          variant="primary"
          @click="requestReport(report)"
        >
          View Full Report {{ reportRequestURLs.length > 1 ? index + 1 : "" }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import pmpServer from "../../server/pmp";

export default {
  name: "EocPmpModal",
  props: ["eocId", "reportRequestURLs", "narxMessages", "narxScores"],
  async mounted() {},
  methods: {
    requestReport(reportUrl) {
      pmpServer.requestReport(this.eocId, reportUrl).then(reportResponse => {
        window.open(reportResponse.reportLink, "_blank");
      });
    }
  },
  computed: {
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style scoped>
span {
  font-size: 11px;
  margin-bottom: 5px;
  font-weight: 700;
  font-family: sans-serif;
}

.col {
  text-align: center;
}

.large {
  font-size: 20px;
}

small {
  font-weight: 100;
}

@media (min-width: 992px) {
  /deep/ .modal-dialog {
    max-width: 650px !important;
  }
}
</style>
